export interface IUrlFormatter {
    langPrefix: string;
}

export class UrlFormatter {
    private langPrefix: string;

    constructor(config: IUrlFormatter) {
        this.langPrefix = this.prefixHandler(config.langPrefix);
    }

    private prefixHandler = (prefix: string | null | undefined) => {
        return prefix !== null && prefix !== undefined ? prefix.replace(/^\/+|\/+$/g, '') : '';
    };

    public langPrefixUrl = (url: string = '') => {
        return this.langPrefix !== '' ? `/${this.langPrefix}${url}` : url;
    };
}
